var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 246.3 291.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wclogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 232.8,
    width: 245.7,
    height: 7.09,
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,262.9h7.9l2.5.5a9.5,9.5,0,0,1,2.4,1.1,7.4,7.4,0,0,1,2.1,2,10.4,10.4,0,0,1,1.5,3.2,16.8,16.8,0,0,1,.6,4.6v1.3a21.9,21.9,0,0,1-.5,5.1,13.1,13.1,0,0,1-1.4,3.5,8,8,0,0,1-2,2.3,8.7,8.7,0,0,1-2.3,1.3,10.4,10.4,0,0,1-2.4.6H12.4v11.3H6.8Zm5.9,21.6a6.5,6.5,0,0,0,2.6-.4,3.7,3.7,0,0,0,1.7-1.4,6.5,6.5,0,0,0,.9-2.4,20.2,20.2,0,0,0,.3-3.6v-3.3a14.8,14.8,0,0,0-.2-2.8,4.6,4.6,0,0,0-.9-2,3.6,3.6,0,0,0-1.7-1.2,7.7,7.7,0,0,0-2.6-.4h-.3v17.5Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#5d5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,262.9h5.6v15.5h6.6V262.9h5.6v37H75.8V282.8H69.1v17.1H63.5Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#5d5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4,300.2h-1.9a7.5,7.5,0,0,1-2.1-.6,7.5,7.5,0,0,1-3.6-3.5,13.1,13.1,0,0,1-1.2-3.4,22.9,22.9,0,0,1-.4-4.8V274.8a22.1,22.1,0,0,1,.4-4.8,12.9,12.9,0,0,1,1.2-3.3,7.4,7.4,0,0,1,1.7-2.2,7.3,7.3,0,0,1,2-1.2l2-.6h3.7l2,.5a7.1,7.1,0,0,1,3.6,3.3,12.9,12.9,0,0,1,1.2,3.4,22.7,22.7,0,0,1,.4,4.8v13.1a21.4,21.4,0,0,1-.5,4.7,13.6,13.6,0,0,1-1.2,3.4,7.7,7.7,0,0,1-1.7,2.2,8.5,8.5,0,0,1-2,1.3,7.4,7.4,0,0,1-2,.6Zm0-4.2a3.4,3.4,0,0,0,1.4-.3,2.3,2.3,0,0,0,1-1,5.7,5.7,0,0,0,.6-1.8,16.6,16.6,0,0,0,.2-2.9V273.2a17.9,17.9,0,0,0-.2-3,6.2,6.2,0,0,0-.6-1.9,2.4,2.4,0,0,0-1-1,3.2,3.2,0,0,0-1.4-.3,3.3,3.3,0,0,0-1.5.3,2.4,2.4,0,0,0-1,1,6,6,0,0,0-.6,1.9,17.8,17.8,0,0,0-.2,3V290a16.5,16.5,0,0,0,.2,2.9,5.5,5.5,0,0,0,.6,1.8,2.3,2.3,0,0,0,1,1A3.6,3.6,0,0,0,131.4,296Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#5d5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,267.3h-6v-4.4h17.5v4.4h-5.9v32.5h-5.6Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#5d5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6,300.2h-1.9a7.5,7.5,0,0,1-2.1-.6A7.5,7.5,0,0,1,236,296a13.1,13.1,0,0,1-1.2-3.4,22.9,22.9,0,0,1-.4-4.8V274.8a22.1,22.1,0,0,1,.4-4.8,12.9,12.9,0,0,1,1.2-3.3,7.4,7.4,0,0,1,1.7-2.2,7.3,7.3,0,0,1,2-1.2l2-.6h3.7l2,.5a7.1,7.1,0,0,1,3.6,3.3,12.9,12.9,0,0,1,1.2,3.4,22.7,22.7,0,0,1,.4,4.8v13.1a21.4,21.4,0,0,1-.5,4.7,13.6,13.6,0,0,1-1.2,3.4,7.7,7.7,0,0,1-1.7,2.2,8.5,8.5,0,0,1-2,1.3,7.4,7.4,0,0,1-2,.6Zm0-4.2a3.4,3.4,0,0,0,1.4-.3,2.3,2.3,0,0,0,1-1,5.7,5.7,0,0,0,.6-1.8,16.6,16.6,0,0,0,.2-2.9V273.2a17.9,17.9,0,0,0-.2-3,6.2,6.2,0,0,0-.6-1.9,2.4,2.4,0,0,0-1-1,3.2,3.2,0,0,0-1.4-.3,3.3,3.3,0,0,0-1.5.3,2.4,2.4,0,0,0-1,1,6,6,0,0,0-.6,1.9,17.8,17.8,0,0,0-.2,3V290a16.5,16.5,0,0,0,.2,2.9,5.5,5.5,0,0,0,.6,1.8,2.3,2.3,0,0,0,1,1A3.6,3.6,0,0,0,243.6,296Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#5d5c5c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6,230a44.6,44.6,0,0,1-6.2-.5,24.2,24.2,0,0,1-6.6-2,24.4,24.4,0,0,1-6.3-4.2,25.2,25.2,0,0,1-5.3-7.2,44.1,44.1,0,0,1-3.7-11.1A77.1,77.1,0,0,1,7,189.4v-43a74.5,74.5,0,0,1,1.4-15.7,43.4,43.4,0,0,1,3.8-11,24,24,0,0,1,5.4-7.1,24.3,24.3,0,0,1,6.3-4,25,25,0,0,1,6.5-1.8,46.2,46.2,0,0,1,6-.4,31.7,31.7,0,0,1,12.1,2,20,20,0,0,1,7.8,5.5,21,21,0,0,1,4.2,8.2,38.8,38.8,0,0,1,1.2,10,61.8,61.8,0,0,1-.4,7.2q-.4,3.3-1.2,7.3H45.4v-6.2q0-10-2.2-15t-6.5-5a9.6,9.6,0,0,0-4.5,1,7.8,7.8,0,0,0-3.2,3.4,21,21,0,0,0-2,6.3,58.6,58.6,0,0,0-.7,9.7v55.5a69.4,69.4,0,0,0,.5,9.5,18.5,18.5,0,0,0,1.7,6,7.2,7.2,0,0,0,3.2,3.2,10.6,10.6,0,0,0,4.7,1,7.5,7.5,0,0,0,3.4-.8,7.9,7.9,0,0,0,2.9-2.6,14.1,14.1,0,0,0,2-4.4,23.5,23.5,0,0,0,.7-6.3V190.1H62.5v11.2q0,14.7-6.7,21.6T36.6,230Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9,230a47.3,47.3,0,0,1-6.3-.5,24.6,24.6,0,0,1-6.8-2,24.8,24.8,0,0,1-11.9-11.5,42.9,42.9,0,0,1-3.8-11.1,75.1,75.1,0,0,1-1.4-15.7v-43a72.8,72.8,0,0,1,1.5-15.7,42.3,42.3,0,0,1,3.9-11,24.6,24.6,0,0,1,5.5-7.1,24.2,24.2,0,0,1,6.5-4,26.5,26.5,0,0,1,6.7-1.8,49.2,49.2,0,0,1,6.2-.4,51.7,51.7,0,0,1,6,.4,26.2,26.2,0,0,1,6.6,1.7,24.1,24.1,0,0,1,6.4,3.9,23.8,23.8,0,0,1,5.6,7,42.4,42.4,0,0,1,3.9,11,74.6,74.6,0,0,1,1.5,15.9v43a70.3,70.3,0,0,1-1.5,15.5,44.5,44.5,0,0,1-3.9,11,25.2,25.2,0,0,1-5.6,7.3,27.7,27.7,0,0,1-6.5,4.3,24.4,24.4,0,0,1-6.6,2A39.8,39.8,0,0,1,103.9,230Zm0-13.9a11.3,11.3,0,0,0,4.7-.9A7.5,7.5,0,0,0,112,212a18.8,18.8,0,0,0,2-6,54.5,54.5,0,0,0,.7-9.4V141.3a58.9,58.9,0,0,0-.7-9.7,20.3,20.3,0,0,0-2-6.3,7.8,7.8,0,0,0-3.3-3.4,10.6,10.6,0,0,0-4.7-1,11,11,0,0,0-4.8,1,7.9,7.9,0,0,0-3.4,3.4,19.6,19.6,0,0,0-2,6.3,58.7,58.7,0,0,0-.7,9.7v55.3a54.4,54.4,0,0,0,.7,9.4,18.2,18.2,0,0,0,2,6,7.6,7.6,0,0,0,3.4,3.2A11.7,11.7,0,0,0,103.9,216.1Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,107.4h18.4v107h25.1v14.5H151.3Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,107.4h45v14.5H224.9v36.4h20.6v14.5H224.9v41.6h27.3v14.5H206.5Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "gray"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7,8.5H19.2l5.8,51.7.7,12.1h1.3L28,58.7,37.3,8.5H47.6l8.8,50.2,1,13.6h1.3l.6-12.1L64.6,8.5H77.1l-12,85.6H52L44.9,53,42.7,35.1h-1L39.5,53,32.1,94.1h-13Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#bfbebe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3,8.5h13V94.1h-13Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#bfbebe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.9,8.5h13V83.9h17.7V94.1H113.9Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#bfbebe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,8.5h13V83.9h17.7V94.1H152.8Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#bfbebe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,8.5h13V94.1h-13Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#bfbebe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.3,8.5h31.7V18.7H232.3V44.4h14.5V54.6H232.3V83.9h19.2V94.1H219.3Z",
    transform: "translate(-6.4 -8.5)",
    style: {
      fill: "#bfbebe"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.47a41848400c841864f5305d59406ae9.svg";
export { ForwardRef as ReactComponent };